import { Component, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { FormBuilder } from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import SwalAlert from 'src/app/utils/swalalert';
import { BookingsAmortizationExtendsComponent } from '../bookings-amortization-extends/bookings-amortization-extends.component';
import { constants } from 'src/app/constants';
import { BookingsCommissionExtendsComponent } from '../bookings-commission-extends/bookings-commission-extends.component';
import { TransfersExtendsComponent } from '../../transfers/transfers-extends/transfers-extends.component';
import { GroupDetailExtendsComponent } from 'src/app/departure/group/group-detail-extends/group-detail-extends.component';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import { UploadFileMovementsExtendsComponent } from 'src/app/components/upload-file-movements-extends/upload-file-movements-extends.component';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-bookings-detail',
  templateUrl: './bookings-detail.component.html',
  styleUrls: ['./bookings-detail.component.css']
})
export class BookingsDetailComponent {
  @ViewChild(BookingsAmortizationExtendsComponent)
  BookingsAmortizationExtendsComponent: any;
  @ViewChild(BookingsCommissionExtendsComponent)
  BookingsCommissionExtendsComponent: any;
  @ViewChild(TransfersExtendsComponent) TransfersExtendsComponent: any;
  @ViewChild(GroupDetailExtendsComponent) GroupDetailExtendsComponent: any;
  @ViewChild(UploadFileMovementsExtendsComponent)
  UploadFileMovementsExtendsComponent: any;
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;

  branchofficeSlug: string = '';
  nameMenu: string = 'gallery_image';
  checkId: number;
  book: any = null;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // arrays
  company: any = null;
  tours: any = [];
  hotels: any = [];
  movements: any = [];
  commissions: any = [];

  typevoucher_boleta: any = null;
  typevoucher_factura: any = null;
  typevoucher_income: any = null;
  typevoucher_expense: any = null;
  typevoucher_ordernote: any = null;

  // for audit info
  audits_results: any = [];
  selectedAudit: any = null;
  expandedIndex: number | null = null;
  filteredAuditsBooking: any[] = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private globalService: GlobalService,
    private bookingsService: BookingsService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];

    this.typevoucher_boleta = this.toolsService.searchObjByKey(
      'BOLETA_ELECTRONICA',
      constants.SALE.VOUCHER
    );
    this.typevoucher_factura = this.toolsService.searchObjByKey(
      'FACTURA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_income = this.toolsService.searchObjByKey(
      'RECIBO_INGRESO',
      constants.SALE.VOUCHER
    );

    this.typevoucher_expense = this.toolsService.searchObjByKey(
      'RECIBO_EGRESO',
      constants.SALE.VOUCHER
    );
    this.typevoucher_ordernote = this.toolsService.searchObjByKey(
      'NOTA_PEDIDO',
      constants.SALE.VOUCHER
    );

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    if (this.isEdit) {
      this.editData();
    }
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  editData(check_id = null) {
    this.bookingsService.detail(this.checkId).subscribe({
      next: (data: any) => {
        let result = data.data;
        this.company = this.globalService.getCompany();
        this.book = result.book;
        this.tours = result.tours;
        this.hotels = result.hotels;
        this.movements = result.movements;
        this.commissions = result.commissions;

        // agregar sucursales a la compania
        this.company.branchoffices = result.branchoffices;
      }
    });
  }

  isEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  beforeAmortization(data: any) {
    this.LoadingModalComponent.show();
    this.editData();
    // print si es billing
    if(data.check_billing){
      if(data.billing != false){
        let billing = data.billing;
        let label;
        label =
          '<span class="badge badge-success f-s-12 p-5">' +
          billing.message +
          '</span>';

        if (billing.code == 'pending') {
          label =
            '<span class="badge badge-warning f-s-12 p-5">' +
            billing.message +
            '</span>';
        }

        Swal.fire({
          title: 'EN HORA BUENA!',
          html:
            '<b>Venta registrada correctamente</b>, desea imprimir el comprobante?</br></br>' +
            label +
            ' ',
          icon: 'success',
          showCancelButton: true,
          confirmButtonColor: '#30419B',
          cancelButtonColor: '#787171',
          confirmButtonText: 'Imprimir <i class="fas fa-print m-r-5"></i>',
          cancelButtonText: 'Cancelar'
        }).then(result => {
          if (result.isConfirmed) {
            window.open(
              this.branchofficeSlug +
                '/api/print/billing/document/booking/' +
                data.data.id
            );
          }
        });

      }else{
        Swal.fire({
          title: 'EN HORA BUENA!',
          html:
            '<b>Comprobante registrado correctamente</b>, desea imprimir el comprobante?',
          icon: 'success',
          showCancelButton: true,
          confirmButtonColor: '#30419b',
          confirmButtonText: 'Imprimir <i class="fas fa-print m-r-5"></i>',
          cancelButtonText: 'Cancelar'
        }).then(result => {
          if (result.isConfirmed) {
            window.open(
              this.branchofficeSlug +
                '/api/print/billing/document/booking/' +
                data.data.id
            );
          }
        });
      }
    }
  }

  afterTransfer(data: any) {
    this.editData();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/reserva/editar',
      id
    ]);
  }

  checkIn() {
    let options = {
      title: '¿Estás segur@?',
      message: '¿Esta seguro(a) de confirmar el CHECK-IN de la reserva?',
      cancel: 'Cancelar',
      confirm: 'Confirmar CHECK-IN'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.bookingsService.checkin(this.book.id, this.book).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('CHECK-IN realizado con éxito !');
            this.editData(data.data.id);
          }
        });
      }
    });
  }

  checkOut() {
    let options = {
      title: '¿Estás segur@?',
      message: '¿Esta seguro(a) en ANULAR la reserva?',
      cancel: 'Cancelar',
      confirm: 'ANULAR RESERVA'
    };
    this.alert.confirmDeleteInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.bookingsService.checkout(this.book.id, this.book).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('ANULACIÓN realizado con éxito !');
            this.editData(data.data.id);
          }
        });
      }
    });
  }

  recover() {
    let options = {
      title: '¿Estás segur@?',
      message: '¿Esta seguro(a) de recuperar la reserva?',
      cancel: 'Cancelar',
      confirm: 'Sí, RECUPERAR'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        this.bookingsService.recover(this.book.id, this.book).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('La reserva se ha recuperado con éxito !');
            this.editData(data.data.id);
          }
        });
      }
    });
  }

  bookingAmortization(book: any) {
    book.company = this.company;
    this.BookingsAmortizationExtendsComponent.init(book);
  }

  bookingCommision(book: any) {
    this.BookingsCommissionExtendsComponent.init(book);
  }

  extendsTransfers(book: any, item: any) {
    this.TransfersExtendsComponent.init(book, item);
  }

  groupDetailExtends(group_id: any) {
    this.GroupDetailExtendsComponent.init(group_id);
  }

  printer() {
    (<any>$('#body')).printThis({
      importCSS: true
    });
  }

  getAuditing() {
    this.bookingsService.auditing(this.checkId).subscribe({
      next: (data: any) => {
        this.audits_results = data.audits_results;
        this.filteredAuditsBooking = this.audits_results.filter(
          (audit: { old_values: any; new_values: any }) =>
            !(this.isEmpty(audit.old_values) && this.isEmpty(audit.new_values))
        );
        (<any>$('#modalAuditing')).modal('show');
      }
    });
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  toggleDetails(index: number, audit: any): void {
    if (this.expandedIndex === index) {
      this.expandedIndex = null;
      this.selectedAudit = null;
    } else {
      this.expandedIndex = index;
      this.selectedAudit = audit;
    }
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reservas/reserva/lista']);
  }
}
